var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.432,
    height: 17.432,
    viewBox: "0 0 17.432 17.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "briefcase-2-line",
    d: "M6.358,4.486V1.872A.872.872,0,0,1,7.23,1H14.2a.872.872,0,0,1,.872.872V4.486h3.486a.872.872,0,0,1,.872.872v12.2a.872.872,0,0,1-.872.872H2.872A.872.872,0,0,1,2,17.561V5.358a.872.872,0,0,1,.872-.872Zm11.331,6.973H3.743v5.23H17.689Zm0-5.23H3.743V9.716H6.358V7.973H8.1V9.716h5.23V7.973h1.743V9.716h2.615ZM8.1,2.743V4.486h5.23V2.743Z",
    transform: "translate(-2 -1)",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase2Line);
export default __webpack_public_path__ + "static/media/briefcase-2-line.8fd27739b098f9b1edba582d26117c06.svg";
export { ForwardRef as ReactComponent };